import {COLLECTION_CONTACT_MESSAGE} from './constants';

export function getContactMessageCollectionPath(): string {
  return COLLECTION_CONTACT_MESSAGE;
}
